import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import CachetFinancialsSpinner from "../financials/Cachet/CachetFinancialsSpinner";

const actions = {
  closeModal
};

const spinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <CachetFinancialsSpinner/>
    </TransparentModal>
  );
};

export default connect(
  null,
  actions
)(spinnerModal);



